import { cn } from "@/lib/utils";

interface SkillsGroupedListGroup<T> {
  title: string;
  items: T[];
}

interface SkillsGroupedListProps<T> {
  groups: SkillsGroupedListGroup<T>[];
  getItemKey: (item: T, index: number) => string;
  renderItem: (item: T) => React.ReactNode;
  onSelectItem: (item: T) => void;
}

export function SkillsGroupedList<T>({
  groups,
  getItemKey,
  renderItem,
  onSelectItem,
}: SkillsGroupedListProps<T>) {
  const nonEmptyGroups = groups.filter((group) => group.items.length > 0);

  return nonEmptyGroups.map((group, groupIndex) => (
    <div key={group.title}>
      {groupIndex > 0 && <hr className="bg-border my-2 h-px" />}
      <div className="text-muted-foreground px-2 py-1 text-xs font-bold tracking-wide uppercase">
        {group.title}
      </div>
      {group.items.map((item, itemIndex) => (
        <button
          key={getItemKey(item, itemIndex)}
          className={cn(
            "hover:bg-background-10 min-h-[32px] w-full cursor-pointer rounded px-2 py-1 text-left text-sm transition-colors",
          )}
          onClick={() => onSelectItem(item)}
          type="button"
        >
          {renderItem(item)}
        </button>
      ))}
    </div>
  ));
}
